import React, { useState } from 'react';
import './eval-list-admin.styles.scss';
import { format } from 'date-fns';
import { properCase } from '../../../utils/properCase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import ManageEvalsDropdown from './manage-evals-dropdown.component';

const EvalListAdmin = ({
  evalsToDisplay,
  countLimit,
}) => {

  const [ showEvalDropdown, setShowEvalDropdown ] = useState(false);

  return (
    <table className='eval-list-admin uk-table uk-table-striped'>
      <thead>
        <tr>
          <th>Title</th>
          <th>Created</th>
          <th>Source</th>
          <th className='centered'>CPDU</th>
          <th className='centered'>Hours</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          (evalsToDisplay)
            ?
            Object.values(evalsToDisplay)
              .sort((a, b) => (a.title.toLowerCase() > b.title.toLowerCase()) ? 1 : -1)
              .splice(0, countLimit)
              .map(ev => (
                <tr key={ev.id}>
                  <td>
                    <b>{ev.title}</b><br />
                    <span className='meta'>{ev.path}</span>
                  </td>
                  <td>{format(new Date(ev.ts), "L/d/y")}</td>
                  <td>{properCase(ev.source)}</td>
                  <td className='centered'>{(ev.cpdu) ? 'Yes' : 'No'}</td>
                  <td className='centered'>{ev.hours}</td>
                  <td width="86px" className='dropdown-container'>
                    <div className='buttons'>
                      <button
                        className='g-button med-btn'
                        onClick={() => setShowEvalDropdown((showEvalDropdown === ev.id) ? null : ev.id)}>
                        <FontAwesomeIcon icon={faEllipsisH} />
                      </button>
                    </div>
                    <div className={`eval_more_dropdown ${(showEvalDropdown === ev.id) ? 'active' : ''
                      }`}>
                      <div className='eval_more_dropdown_menu'>
                        <ManageEvalsDropdown 
                          ev={ev}
                          showEvalDropdown={showEvalDropdown}
                          setShowEvalDropdown={setShowEvalDropdown} />
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            : <tr><td></td></tr>
        }
      </tbody>
    </table>
  )
}

export default EvalListAdmin